

export const updateBrandPricesAsync = (materials, brands, baseOptions, currentOptions, priceService) => {
    return updatePriceOptionsAsync(brands, () => getBrandOptions(materials, brands, currentOptions), baseOptions, currentOptions, priceService);
}

export const updateShapePricesAsync = (shapes, baseOptions, currentOptions, priceService) => {
    return updatePriceOptionsAsync(shapes, getShapeOptions, baseOptions, currentOptions, priceService);}

export const updateMaterialPricesAsync = (materials, baseOptions, currentOptions, priceService) => {
    return updatePriceOptionsAsync(materials, getMaterialOptions, baseOptions, currentOptions, priceService);
}
export const updateProfilePricesAsync = (profileMaterials, baseOptions, currentOptions, priceService) => {
    return updatePriceOptionsAsync(profileMaterials, getProfileMaterialOptions, baseOptions, currentOptions, priceService);

}



let updatePriceOptionsAsync = (options, getOptions, baseOptions, currentOptions, priceService) => {
    return getBenchPriceAsync(baseOptions.benchBrand, baseOptions.benchShape, baseOptions.mirrored, baseOptions.benchMaterial, baseOptions.profile, priceService, baseOptions).then((baseprice) => {
        let result = {};
        let pricePromises = [];
        getOptions(options, currentOptions).forEach(option => {
            pricePromises.push(getBenchPriceAsync(option.brand, option.shape, option.mirrored, option.material, option.profile, priceService, baseOptions).then(price => {
                result[option.id] = price - baseprice;
            }));
        });
        return Promise.all(pricePromises).then(() => result);
    });
}

let getBrandOptions = (materials, brands, currentOptions) => {
    let result = [];
    brands.forEach((brand) => {
        let material = (currentOptions.benchBrand === brand) ? currentOptions.benchMaterial : materials.find(m => m.benchModel.includes(brand)).id;
        result.push({
            id: brand,
            material: material,
            brand: brand,
            shape: currentOptions.benchShape,
            profile: currentOptions.profile,
            mirrored: currentOptions.mirrored
        });
    })
    return result;
}


let getShapeOptions = (shapes, currentOptions) => {
    let result = [];
    shapes.forEach((shape) => {
        result.push({
            id: shape,
            material: currentOptions.benchMaterial,
            brand: currentOptions.benchBrand,
            shape: shape,
            profile: currentOptions.profile,
            mirrored: shape.mirrored
        });
    })
    return result;
}

let getMaterialOptions = (materials, currentOptions) => {
    let result = [];
    materials.forEach((material) => {
        result.push({
            id: material,
            material: material,
            brand: currentOptions.benchBrand,
            shape: currentOptions.benchShape,
            profile: currentOptions.profile,
            mirrored: currentOptions.mirrored
        });
    })
    return result;
}

let getProfileMaterialOptions = (materials, currentOptions) => {
    let result = [];
    materials.forEach((pmaterial) => {
        result.push({
            id: pmaterial,
            material: currentOptions.benchMaterial,
            brand: currentOptions.benchBrand,
            shape: currentOptions.benchShape,
            profile: pmaterial,
            mirrored: currentOptions.mirrored
        });
    })
    return result;
}

let getBenchPriceAsync = (brand, shape, mirrored, material, profilematerial, priceService, baseBenchOptions) => new Promise(
    (resolve) => {
        if (baseBenchOptions &&
            baseBenchOptions.benchBasePrice &&
            baseBenchOptions.benchBrand === brand &&
            baseBenchOptions.benchShape === shape &&
            baseBenchOptions.material == material) {
            resolve(baseBenchOptions.benchBasePrice);
        }
        else {
            priceService.getPriceAsync({ brand, shape, mirrored, material, profilematerial}).then(price => {
                resolve(price);
            });                
    }
    }
);